import { createSlice } from '@reduxjs/toolkit';
import axios from '../../config/axios-config';
import { ApiStatusKeys, setApiLoading, setApiSuccess, setApiError } from './apiStatusSlice';
import AppError from '../../models/error';
import { handleApiError } from '../../helpers/errorHelper';

const initialState = {
  categories: [],
  loading: false,
  error: null,
  category: null,
  categoryLoading: false,
  categoryError: null,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.categoryError = null;
    },
    setCategoriesLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.categories = action.payload;
    },
    setCategoriesError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCategoryLoading: (state) => {
      state.categoryLoading = true;
      state.categoryError = null;
    },
    setCategorySuccess: (state, action) => {
      state.categoryLoading = false;
      state.category = action.payload;
    },
    setCategoryError: (state, action) => {
      state.categoryLoading = false;
      state.categoryError = action.payload;
    },
  },
});

export const {
  clearError,
  setCategoriesLoading,
  setCategoriesSuccess,
  setCategoriesError,
  setCategoryLoading,
  setCategorySuccess,
  setCategoryError,
} = categorySlice.actions;

export const getCategories = (useCache) => async (dispatch) => {
  try {
    dispatch(setApiLoading(ApiStatusKeys.GET_CATEGORIES));
    dispatch(setCategoriesLoading());

    const language = localStorage.getItem('i18nextLng') || 'tr';

    const response = await axios({
      method: 'get',
      url: '/category/get-categories?language=' + language + '&useCache=' + useCache,
    });

    if (response.data.success) {
      dispatch(setApiSuccess(ApiStatusKeys.GET_CATEGORIES));
      dispatch(setCategoriesSuccess(response.data.categories));
    } else {
      throw new Error(response.data.errorMessage);
    }
  } catch (error) {
    const errorMessage = handleApiError(error, ApiStatusKeys.GET_CATEGORIES, dispatch, 'errors.category_failed');
    dispatch(setCategoriesError(AppError.validationError(errorMessage)));
  }
};

export const getCategory = (id, useCache) => async (dispatch) => {
  try {
    dispatch(setApiLoading(ApiStatusKeys.GET_CATEGORY));
    dispatch(setCategoryLoading());

    const language = localStorage.getItem('i18nextLng') || 'tr';

    const response = await axios({
      method: 'get',
      url: `/category/get-category-by-id?language=${language}&id=${id}&useCache=${useCache}`,
    });

    if (response.data.success) {
      dispatch(setApiSuccess(ApiStatusKeys.GET_CATEGORY));
      dispatch(setCategorySuccess(response.data.categories[0]));
    } else {
      throw new Error(response.data.errorMessage);
    }
  } catch (error) {
    const errorMessage = handleApiError(error, ApiStatusKeys.GET_CATEGORY, dispatch, 'errors.category_failed');
    dispatch(setCategoryError(AppError.validationError(errorMessage)));
  }
};

export default categorySlice.reducer;
